import form from './form';
import index from './index.js';
import { Router } from '@/legacy/Router';

Router.get('season', index);
Router.get('season/:any', form);
